export default "__VITE_ASSET__BysTh1Hl__"